import { HolidaysListQueryParams } from '@nextforce/api'

const keys = {
  all: ['holidays'],
  list: (params: HolidaysListQueryParams) => [...keys.all, params],
}

export default keys
